/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'ascendente',
  'fabric.editor.headingLink.copied': '¡Copiado!',
  'fabric.editor.headingLink.copyAnchorLink': 'Copiar enlace en el título',
  'fabric.editor.headingLink.copyAriaLabel': 'Copiar',
  'fabric.editor.headingLink.descSortingLabel': 'descendente',
  'fabric.editor.headingLink.failedToCopy': 'Copia fallida',
  'fabric.editor.headingLink.noneSortingLabel': 'ninguno',
  'fabric.editor.inlineComment.marker.end': 'final de comentario insertado',
  'fabric.editor.inlineComment.marker.start': 'inicio de comentario insertado',
};
